import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { SalesFeesPage, SalesFeesHeader, SalesFeesBody } from './SalesFeesComponents';
import { useStore } from '../../context';
import { showToRoles } from '../../utils';
import { RoleGuard } from '../../routes';

export const SalesFees = () => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();
  const [totalCount, setTotalCount] = useState(0);

  if (showToRoles(['YARD_MANAGER', 'YARD_DISPATCHER'], user))
    return <Navigate to={`/dashboard/sales-fees/view/${user.yardEmployee.yardId}`} replace />;

  return (
    <RoleGuard roles={'adminRead'}>
      <SalesFeesPage innerScroll>
        <SalesFeesHeader totalCount={totalCount} />
        <SalesFeesBody setTotalCount={setTotalCount} />
      </SalesFeesPage>
    </RoleGuard>
  );
};
